import React, {
  ChangeEventHandler,
  HTMLInputTypeAttribute,
  useState,
} from "react";
import eyeHide from "@/assets/auth/eye-hide.svg";
import eyeShow from "@/assets/auth/eye-show.svg";
import styles from "../styles/styled-input.module.scss";
import Image from "next/image";

export interface StyledInputPropsBase {
  title?: string;
  placeholder?: string;
  type?: HTMLInputTypeAttribute;
  isDisabled?: boolean;
  isValid?: boolean;
  registerField?: any;
  suffixIcon?: string;
  titleColor?: string;
  error?: string;
}

interface StyledInputProps extends StyledInputPropsBase {
  value?: string;
  pattern?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

const StyledInput = ({
  title,
  type,
  value,
  onChange,
  placeholder,
  isDisabled,
  isValid,
  registerField,
  suffixIcon,
  titleColor,
}: StyledInputProps) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const isTypePassword = type === "password";
  const changePasswordVisibility = () =>
    isPasswordVisible ? "text" : "password";

  const validStyle = isValid ? styles.inp_valid : styles.inp_invalid;
  return (
    <>
      {title && (
        <div
          className={styles.title}
          style={{ color: titleColor ?? "", opacity: titleColor && 1 }}
        >
          {title}
        </div>
      )}
      <div className={styles.inp_container}>
        <input
          type={isTypePassword ? changePasswordVisibility() : type}
          onChange={onChange}
          value={value}
          className={`${styles.inp} ${validStyle}`}
          placeholder={placeholder}
          disabled={isDisabled}
          {...registerField}
        />
        {suffixIcon && (
          <div className={styles.suffix_icon}>
            <Image src={suffixIcon} alt={suffixIcon.toString()} />
          </div>
        )}
        {isTypePassword && (
          <button
            className={styles.eye_button}
            id="password_btn"
            type="button"
            onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          >
            <Image
              className={styles.eye_icon}
              src={isPasswordVisible ? eyeHide : eyeShow}
              alt="hide"
              id="eye_icon"
            />
          </button>
        )}
      </div>
    </>
  );
};
export default StyledInput;
